import { AccountEditPage } from './AccountEditPage';
export default AccountEditPage;
